import {
  Grid,
  GridColumn as Column,
  GridColumnMenuCheckboxFilter,
} from "@progress/kendo-react-grid";
import { Button } from "@progress/kendo-react-buttons";
import * as React from "react";
import OEContext from "../../layouts/OEContext";
import HideDialog from "../../components/HideDialog";
import BenefitPlanRatesModel from "./BenefitPlanRatesModel";
import "@progress/kendo-theme-default/dist/all.css";
import { createPortal } from "react-dom";

const BenefitPlanGrid = ({
  title,
  page,
  size,
  sort,
  planPage,
  onStateChange,
  loading,
}) => {
  const oePeriod = React.useContext(OEContext);

  const [showRatesModel, setShowRatesModel] = React.useState(false);
  const [showDeleteDialog, setShowDeleteDialog] = React.useState(false);
  const [currentViewItem, setCurrentViewItem] = React.useState();
  const gridRef = React.useRef(null);

  const pagerSetting = {
    buttonCount: 5,
    info: true,
    type: "numeric",
    pageSizes: [10, 20, 50, 100, 200, 500],
    previousNext: true,
  };

  const handleDataStateChange = (event) => {
    const newPage = Math.floor(event.dataState.skip / event.dataState.take) + 1;
    const newSize = event.dataState.take;
    const newSort = event.dataState.sort;

    onStateChange(newPage, newSize, newSort);
  };

  const handleCancelView = () => {
    setShowRatesModel(false);
  };

  const handleOpenViewRateWindow = (item) => {
    setCurrentViewItem(item);
    setShowRatesModel(true);
  };

  const handleDelete = async (item) => {
    setShowDeleteDialog(false);
  };

  const ColumnCheckboxMenu = (props) => {
    return (
      <div>
        <GridColumnMenuCheckboxFilter
          {...props}
          data={planPage?.items || []}
          expanded={true}
        />
      </div>
    );
  };

  const loadingPanelMarkup = (
    <div className="k-loading-mask">
      <span className="k-loading-text">Loading</span>
      <div className="k-loading-image" />
      <div className="k-loading-color" />
    </div>
  );

  const LoadingPanel = (props) => {
    const { gridRef } = props;
    const gridContent =
      gridRef.current && gridRef.current.querySelector(".k-grid-content");
    return gridContent
      ? createPortal(loadingPanelMarkup, gridContent)
      : loadingPanelMarkup;
  };

  const actionCell = (props) => {
    return (
      <td>
        <Button
          themeColor="info"
          onClick={() => handleOpenViewRateWindow(props.dataItem)}
        >
          View Rates
        </Button>
      </td>
    );
  };

  const skip = (page - 1) * size;

  return (
    <div>
      <div
        style={{
          justifyContent: "space-between",
          display: "flex",
          paddingBottom: 10,
        }}
      >
        <div>
          <h2 style={{ margin: "10px" }}>{title}</h2>
        </div>
      </div>
      {loading ? <LoadingPanel gridRef={gridRef} /> : null}
      <Grid
        style={{ height: "600px" }}
        pageable={pagerSetting}
        sortable={{ allowUnsort: true, mode: "multiple" }}
        loading={loading}
        data={planPage?.items || []}
        total={planPage?.totalCount || 0}
        skip={skip}
        take={size}
        sort={sort}
        onDataStateChange={handleDataStateChange}
      >
        <Column
          field="planId"
          sortable={true}
          // columnMenu={ColumnCheckboxMenu}
          title="Plan Id"
        />
        <Column
          field="planDesc"
          // columnMenu={ColumnCheckboxMenu}
          title="Plan Desc"
        />
        <Column
          field="dpPlanId"
          // columnMenu={ColumnCheckboxMenu}
          title="DP Plan Id"
        />
        <Column
          field="dpPlanDesc"
          // columnMenu={ColumnCheckboxMenu}
          title="DP Plan Desc"
        />
        <Column
          field="Action"
          title="Action"
          cell={actionCell}
          sortable={false}
        />
      </Grid>

      {showRatesModel && (
        <BenefitPlanRatesModel
          onClose={handleCancelView}
          planId={currentViewItem.planId}
          oePeriodId={oePeriod?.oePeriodId}
        />
      )}

      {showDeleteDialog && (
        <HideDialog
          onHide={handleDelete}
          onCancel={() => setShowDeleteDialog(false)}
          item={currentViewItem}
        />
      )}
    </div>
  );
};

export default BenefitPlanGrid;
